// https://www.bigbinary.com/react-best-practices/prefer-axios-over-fetch
import axios from "axios";
import Cookies from "js-cookie";
import persianRex from "persian-rex";
import { Notif } from "../components/notification";

const requestHandler = (request) => request;

const responseSuccessHandler = (response) => {
    const { data } = response;
    if (data?.data?.result === "warning") {
        Notif.show(data.message, "warning");
        data.message = "";
    }

    return data;
};

const responseErrorHandler = (error) => {
    const status = error.response.status;

    if (status === 401) {
        Cookies.remove("access_token");
        sessionStorage.clear();
        localStorage.clear();
        document.cookie.replace(
            /(?<=^|;).+?(?=\=|;|$)/g,
            (name) => location.hostname
                .split(/\.(?=[^\.]+\.)/)
                .reduceRight((acc, val, i, arr) => i ? arr[i]="."+val+acc : (arr[i]="", arr), "")
                .map((domain) => document.cookie=`${name}=;max-age=0;path=/;domain=${domain}`)
        );
        window.location.href = "/";
    } else if (status === 422) {
        const data = error.response.data;
        if (data.message) {
            Notif.show(data.message, "error");
        }

        if (Object.keys(data.data).length > 0) {
            Object.entries(data.data).forEach(([key, value]) => {
                const elm = $(`[name="${key}"]`);
                if (elm.length > 0) {
                    elm.addClass("is-invalid")
                        .siblings(".invalid-feedback")
                        .text(value);
                } else {
                    Notif.show(value, "error");
                }
            });
        }
        return Promise.reject(data);
    } else {
        const data = error.response.data;
        if (data.message) {
            if (persianRex.hasLetter.test(data.message)) {
                Notif.show(data.message, "error");
            } else {
                Notif.show("پردازش مورد نظر موفقیت آمیز نبود", "error");
            }
        } else {
            Notif.show("پردازش مورد نظر موفقیت آمیز نبود", "error");
        }
        return Promise.reject(data);
    }
};

/**
 *
 *
 * @class API
 */
class API {
    /**
     * Creates an instance of API.
     * @param {string} [base_url='/api/v1/']
     * @memberof API
     */
    constructor(base_url = "/api/v1/") {
        this.axios_insatnce = axios.create({
            baseURL: base_url,
            headers: {},
        });

        this.default_header = {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")
        };

        this.axios_insatnce.interceptors.request.use((request) =>
            requestHandler(request)
        );

        this.axios_insatnce.interceptors.response.use(
            (response) => responseSuccessHandler(response),
            (error) => responseErrorHandler(error)
        );
    }

    // https://axios-http.com/docs/req_config
    /**
     *
     * @param {"GET"|"POST"|"PUT"|"PATCH"|"DELETE"} method method of the request
     * @param {string} url
     * @param {Object} data
     * @param {Object} headers
     * @param {Object} params
     * @param {AxiosRequestConfig} other_options
     * @return {Promise<AxiosResponse<any>>}
     */
    send(
        method,
        url,
        data = null,
        headers = null,
        params = null,
        other_options = {}
    ) {
        return this.axios_insatnce.request({
            method,
            url,
            params,
            data,
            headers: { ...this.default_header, ...headers },
            ...other_options,
        });
    }
}

export default API;
export { API };
